// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export class CtsGantryLogFilterModel {
  public searchInput = '';
  public errors = false;
  public warnings = false;
  public informations = false;
}
